<template>
  <div style="margin-top: 5px">
    <el-col :span="1.5">
      <el-upload
        ref="upload"
        style="margin-right: 10px"
        class="upload-demo"
        :action="sys_app_logoAction"
        accept="xlsx"
        :headers="headers"
        :limit="1"
        :on-success="(res)=>{return importUploadSuccess(res)}"
        :before-upload="analysisExcel"
      >
        <el-button :v-permisaction="[importP]" icon="el-icon-upload2" size="mini" type="primary">{{ importTitle }}</el-button>
      </el-upload>
    </el-col>

    <el-col :span="1.5">
      <el-button v-if="exportShow" :v-permisaction="[exportP]" type="primary" icon="el-icon-download" size="mini" @click="exportData()">{{ exportTitle }}</el-button>
    </el-col>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { uploadMultiSheet } from '@/utils/excel'
export default {
  name: 'CommonExcel',
  props: {
    exportShow: {
      type: Boolean,
      default: true
    },
    importTitle: {
      type: String,
      default: '导入'
    },
    exportTitle: {
      type: String,
      default: '导出'
    },
    importMethod: {
      type: Function,
      required: true
    },
    exportMethod: {
      type: Function,
      required: false,
      default: () => {}
    },
    getTable: {
      type: Function,
      required: false,
      default: () => {}
    },
    importP: {
      type: String,
      required: false,
      default: ''
    },
    exportP: {
      type: String,
      required: false,
      default: ''
    },
    transaction: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      excelData: [],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile'
    }
  },
  methods: {
    analysisExcel(file) {
      this.excelData = []
      uploadMultiSheet(file, (data) => {
        const out = []
        for (let i = 0; i < data.results.length; i++) {
          const sheet = data.sheet[i]
          const results = data.results[i]
          const sheetData = this.makeDataFromExcel(results[0], this.excelDataWithOutKeys(results))
          if (sheetData[0] === false) {
            return false
          }
          out.push({ sheetName: sheet, sheetData: sheetData[1] })
        }
        this.excelData = out
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      this.importMethod({ path: response.data.path, data: this.excelData })
    },
    exportData() {
      this.exportMethod()
    },
    excelDataWithOutKeys(list) {
      const out = []
      for (let i = 1; i < list.length; i++) {
        out.push(list[i])
      }
      return out
    },
    makeDataFromExcel(keys, list) {
      try {
        if (keys.length === 0) {
          return []
        }
        const actionKeys = []
        const deep = {}
        const complexKey = {}
        for (let i = 0; i < keys.length; i++) {
          if (keys[i].indexOf('.') !== -1) {
            const key = []
            let key2 = []
            const tmp = keys[i].split('.')
            if (tmp[0].indexOf('#') !== -1) {
              key2 = tmp[0].split('#')
              key.push(key2[0], parseInt(key2[1]))
              if (deep[key2[0]] === undefined) {
                deep[key2[0]] = []
              }
            }
            key.push(tmp[1])
            actionKeys.push(key)
            if (deep[key2[0]].length === 0) {
              deep[key2[0]].push(key2[0], parseInt(key2[1]), tmp[1])
            }
            if (complexKey[key2[0]] === undefined) {
              complexKey[key2[0]] = []
            }
            complexKey[key2[0]].push(tmp[1])
          } else if (keys[i].indexOf('#') !== -1) {
            const key = []
            const key2 = keys[i].split('#')
            key.push(key2[0], parseInt(key2[1]))
            actionKeys.push(key)
            if (deep[key2[0]] === undefined) {
              deep[key2[0]] = []
              deep[key2[0]].push(key2[0], parseInt(key2[1]))
            }
          } else {
            actionKeys.push(keys[i])
          }
        }
        const data = []
        for (let i = 0; i < list.length; i++) {
          let j = 0
          const row = {}
          for (let k = 0; k < actionKeys.length; k++, j++) {
            if (typeof actionKeys[k] === 'string') {
              row[actionKeys[k]] = list[i][j] === undefined ? '' : list[i][j]
            } else if (actionKeys[k] instanceof Array) {
              if (list[i][j] !== undefined) {
                this.makeData(row, actionKeys[k], list[i][j])
              }
            }
          }
          for (const rowKey in deep) {
            this.checkData(row, deep[rowKey])
          }
          for (const rowKey in complexKey) {
            this.checkComplexKey(row[rowKey], complexKey[rowKey])
          }
          data.push(row)
        }
        return [true, data]
      } catch (e) {
        this.msgError('Excel 报错：' + e)
        return [false, []]
      }
    },
    makeData(obj, keys, value, index = 0) {
      if (keys.length - 1 > index) {
        if (obj[keys[index]] === undefined) {
          obj[keys[index]] = {}
        }
        this.makeData(obj[keys[index]], keys, value, index + 1)
      } else {
        obj[keys[index]] = value === undefined ? '' : value
      }
    },
    checkData(obj, deep, index = 0) {
      if (deep.length > index) {
        if (typeof deep[index] === 'number') {
          const tmp = []
          for (const objKey in obj) {
            if (obj[objKey] === '') {
              continue
            }
            tmp.push(obj[objKey])
          }
          return tmp
        } else {
          obj[deep[index]] = this.checkData(obj[deep[index]], deep, index + 1)
        }
      }
    },
    checkComplexKey(list, keys) {
      keys = [...new Set(keys)]
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < keys.length; j++) {
          if (list[i][keys[j]] === undefined) {
            list[i][keys[j]] = ''
          }
        }
      }
      for (let i = 0; i < list.length; i++) {
        let num = 0
        for (let j = 0; j < keys.length; j++) {
          if (list[i][keys[j]] === '') {
            num++
          }
        }
        if (num >= keys.length) {
          list.splice(i, 1)
        }
      }
    },
    tranToTarget(list, data, exportFlag = true, equalTo = 'key', target = 'value') {
      list = JSON.parse(JSON.stringify(list))
      data = JSON.parse(JSON.stringify(data))
      const unMatchRow = []
      for (const key in data) {
        data[key].sort((a, b) => {
          return a[target].length < b[target].length ? 1 : -1
        })
        for (let i = 0; i < list.length; i++) {
          if (list[i][key] === '' || list[i][key] === 0 || list[i][key] === undefined) {
            continue
          }
          if (list[i][key] instanceof Array) {
            for (let k = 0; k < list[i][key].length; k++) {
              let match = false
              for (let j = 0; j < data[key].length; j++) {
                if (list[i][key][k].toString() === data[key][j][equalTo].toString()) {
                  list[i][key][k] = data[key][j][target]
                  match = true
                  break
                }
              }
              if (!match) {
                unMatchRow.push({ id: i + 1, key: key, value: list[i][key][k] })
              }
            }
          } else {
            let match = false
            for (let j = 0; j < data[key].length; j++) {
              if (list[i][key].toString() === data[key][j][equalTo].toString()) {
                list[i][key] = data[key][j][target]
                match = true
                break
              }
            }
            if (!match) {
              unMatchRow.push({ id: i + 1, key: key, value: list[i][key] })
            }
          }
        }
      }
      if (!exportFlag && unMatchRow.length > 0) {
        this.msgError(unMatchRow[0].id + '行:' + unMatchRow[0].key + '配置 ' + unMatchRow[0].value + ' 匹配失败,请检查配置')
        return []
      }
      return list
    },
    countKeyLen(list, key, defaultLen = 0) {
      let len = defaultLen
      for (let i = 0; i < list.length; i++) {
        if (list[i][key].length > len) {
          len = list[i][key].length
        }
      }
      return len
    },
    makeArrayTitleAndKeys(title, keys, len, zhName = '标签', key = 'label') {
      for (let i = 0; i < len; i++) {
        title.push(zhName + '#' + (i + 1))
        keys.push(key + '#' + (i + 1))
      }
      return [title, keys]
    },
    makeKeysHeader(keys, list) {
      const out = []
      out.push(keys)
      for (let i = 0; i < list.length; i++) {
        out.push(list[i])
      }
      return out
    },
    makeArrayObjectTitleAndKeys(title, keys, len, zhName = '标签', key = 'label', object = {}) {
      for (let i = 0; i < len; i++) {
        for (const oKey in object) {
          title.push(zhName + '#' + (i + 1) + '.' + object[oKey])
          keys.push(key + '#' + (i + 1) + '.' + oKey)
        }
      }
      return [title, keys]
    },
    countMaxLen(list, key, defaultLen = 1) {
      for (let i = 0; i < list.length; i++) {
        const len = list[i][key].length
        if (len > defaultLen) {
          defaultLen = len
        }
      }
      return defaultLen
    },
    arrayTitleAKeys(len, key, zhName) {
      const title = []
      const keys = []
      for (let i = 0; i < len; i++) {
        title.push(zhName + '#' + (i + 1))
        keys.push(key + '#' + (i + 1))
      }
      return [title, keys]
    },
    arrayObjectTitleAKeys(len, key, zhName, object) {
      const title = []
      const keys = []
      for (let i = 0; i < len; i++) {
        for (const oKey in object) {
          title.push(zhName + '#' + (i + 1) + '.' + object[oKey])
          keys.push(key + '#' + (i + 1) + '.' + oKey)
        }
      }
      return [title, keys]
    },
    // tranTitle: {id:"ID",name:"名称",label:{name:"标签",sub:[]},reward:{name:"奖励",sub: {propsId:"道具",num:"数量",val:"附加值"}}}
    makeExcelData(list, tranTitle) {
      const actionKeys = []
      const title = []
      const keys = []
      const content = []
      for (const key in tranTitle) {
        if (typeof tranTitle[key] === 'string') {
          title.push(tranTitle[key])
          keys.push(key)
          actionKeys.push({ type: 'String', key: key })
        } else if (tranTitle[key] instanceof Object) {
          const len = this.countMaxLen(list, key, 1)
          if (tranTitle[key].sub instanceof Array) {
            const tk = this.arrayTitleAKeys(len, key, tranTitle[key].name)
            title.push(...tk[0])
            keys.push(...tk[1])
            actionKeys.push({ type: 'Array', key: key, len: len })
          } else if (tranTitle[key].sub instanceof Object) {
            const tk = this.arrayObjectTitleAKeys(len, key, tranTitle[key].name, tranTitle[key].sub)
            title.push(...tk[0])
            keys.push(...tk[1])
            actionKeys.push({ type: 'Object', key: key, len: len, sub: tranTitle[key].sub })
          }
        }
      }
      for (let i = 0; i < list.length; i++) {
        const data = list[i]
        const tmp = []
        for (const dataKey in actionKeys) {
          const t = actionKeys[dataKey]
          if (t.type === 'String') {
            tmp.push(data[t.key])
          } else if (t.type === 'Array') {
            for (let j = 0; j < t.len; j++) {
              tmp.push(data[t.key][j] ?? '')
            }
          } else if (t.type === 'Object') {
            if (Object.prototype.toString.call(data[t.key]) === '[object Object]') { // {}
              for (const key in t.sub) {
                // eslint-disable-next-line no-prototype-builtins
                if (t.sub.hasOwnProperty(key)) {
                  tmp.push(data[t.key][key])
                }
              }
            } else { // [{}]
              for (let j = 0; j < t.len; j++) {
                for (const tKey in t.sub) {
                  if (data[t.key][j] !== undefined && data[t.key][j] !== null) {
                    tmp.push(data[t.key][j][tKey])
                  } else {
                    tmp.push('')
                  }
                }
              }
            }
          }
        }
        content.push(tmp)
      }
      const out = []
      out.push(keys)
      out.push(...content)
      return [title, out]
    }
  }
}
</script>

<style scoped>

</style>

